/**
 * Created by Ning Jiang on 2022-04-01.
 */

import {RoadKill} from "../RoadKill";

export class BelowStakeWinRestriction {
    public static isWinBelowStake(): boolean {
        return RoadKill.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (RoadKill.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static getBuyFeaturePrice(): number {
        const betLevel: string = RoadKill.apiPlugin.freeBets.hasFreeBets() ? RoadKill.apiPlugin.freeBets.getBet() : RoadKill.apiPlugin.betLevel.getLevel();
        let price: number = RoadKill.model.gameData?.playedBetValue || parseFloat(betLevel);
        const activeFeature = RoadKill.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeFeature) {
            price = activeFeature.getTotalCost();
        }
        return price;
    }
}